import { ComponentPropsWithoutRef, MouseEvent, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import { Box } from '../../../common/ui/Box';
import { theme } from '../../../common/ui/theme';

interface DefaultCellProps extends ComponentPropsWithoutRef<'td'> {
    numeric?: boolean;
    emphasis?: 'default' | 'attention';
    interactive?: boolean;
    children?: ReactNode;
    hideOnLoading?: boolean;
    isLoading?: boolean;
    truncate?: boolean;
    disabled?: boolean;
}

const StyledDefaultCell = styled.td.attrs((props) => ({
    emphasis: 'default',
    hideOnLoading: false,
    truncate: false,
    ...props,
}))<DefaultCellProps>`
    border-top: 1px solid ${theme.colors.background.inset};
    color: ${(props) => (props.emphasis === 'attention' ? theme.colors.attention.foreground : 'inherit')};
    text-align: ${(props) => (props.numeric ? 'right' : 'left')};
    pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

    ${(props) => (props.truncate ? 'max-width: 0' : '')};

    &:not(:has(*)) {
        padding-left: 16px;
        padding-right: 16px;
    }

    &:has(*) > *:first-child {
        padding-left: 16px;
        padding-right: 16px;
    }
`;

export const DefaultCell = (props: DefaultCellProps) => {
    const onClick = (event: MouseEvent) => {
        if (props.interactive && !props.disabled) {
            event.stopPropagation();
        }
    };

    return (
        <StyledDefaultCell {...props} onClick={onClick}>
            {props.isLoading && !props.hideOnLoading ? (
                <Box
                    height={40}
                    display="flex"
                    alignItems="center"
                    justifyContent={props.numeric ? 'flex-end' : 'flex-start'}
                >
                    <Box width="70%">
                        <Skeleton height={16} />
                    </Box>
                </Box>
            ) : null}

            {!props.isLoading ? props.children : null}
        </StyledDefaultCell>
    );
};
